import { render, staticRenderFns } from "./MpMillionairesQuestionV2.vue?vue&type=template&id=3e51fe92&scoped=true&"
import script from "./MpMillionairesQuestionV2.vue?vue&type=script&lang=js&"
export * from "./MpMillionairesQuestionV2.vue?vue&type=script&lang=js&"
import style0 from "./MpMillionairesQuestionV2.vue?vue&type=style&index=0&id=3e51fe92&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e51fe92",
  null
  
)

export default component.exports